/**
 * =============================================================================
 * !!! README !!!
 * =============================================================================
 *
 * This is a very lightly modified version of the CountrySelect component from MUI Documentation.
 * https://mui.com/material-ui/react-autocomplete/#country-select
 *
 * The {@link Autocomplete} component returns a wrapper function with a large amount of props that are meant
 * to be injected (via spreading) into the input field. This is not a pattern that is used in the rest of the codebase.
 *
 * Any ts-ignore comments are there to suppress errors from the linter.
 * Any eslint-disable comments are there to suppress errors from the linter.
 *
 * These patterns should not be used in the rest of the codebase.
 * And this file should not be used as a reference for best practices.
 */
import Autocomplete from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { useState } from 'react'
import { countries } from './countries'

interface Props {
  error?: String | null
}

const defaultValue = 'US'

export default function CountrySelect({ error }: Props) {
  const [countryCode, setCountryCode] = useState(defaultValue)
  return (
    <>
      <Autocomplete
        id="country-select-demo"
        sx={{ width: '100%' }}
        defaultValue={countries[0]}
        onChange={(_event, value) => setCountryCode(value?.code ?? '')}
        options={countries}
        autoHighlight
        getOptionLabel={(option) => option.label}
        renderOption={(props, option) => {
          const { ...optionProps } = props
          return (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...optionProps}>
              <img
                loading="lazy"
                width="20"
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                alt=""
              />
              {option.label}
            </Box>
          )
        }}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            required
            data-testid="country"
            placeholder="Country"
            error={Boolean(error)}
            size="small"
            variant="outlined"
            sx={{
              mt: 2,
              '& fieldset': {
                borderRadius: '8px'
              }
            }}
            // @ts-ignore
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: 'new-password' // disable autocomplete and autofill
              }
            }}
          />
        )}
      />
      <input value={countryCode} type="hidden" name="country" id="country" data-recurly="country" />
    </>
  )
}

CountrySelect.defaultProps = {
  error: null
}
